import { useCurrentUser } from '@shared/hooks';
import { Navigate } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { Routes } from '@shared/enums';
import { FC } from 'react';

export const CompanyNotFound: FC = () => {
  const { companyId } = useCurrentUser();

  Sentry.captureException(new Error(`Route ${window.location.pathname} not found`), {
    extra: { companyId, route: window.location.pathname },
    level: 'error',
  });

  return <Navigate to={companyId ? `/${companyId}` : Routes.NOT_FOUND} replace />;
};
